import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

const MOBILE_LABELS = ['Main Bet', 'Big Card', 'Zero Card', 'Any Zero Card'];
const SUBTYPES = ['race17', 'bigcard', 'zerocard', 'anyzero'];

// Race to 17 — 4 back/lay markets (race17/bigcard/zerocard/anyzero via subtype).
// Web = row5 col-3 (nat name + back/lay + book), mobile = row5 casino-bl-box stack
// (Main Bet/Big Card/Zero Card/Any Zero Card + back/lay + book). book-black hamesha.
const BetTableRace17 = memo(function BetTableRace17({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const items = SUBTYPES.map((st) => sub.find((s) => s.subtype === st));

  return (
    <>
      {/* Desktop */}
      <div className="row row5 d-none-small">
        {items.map((item, i) => {
          const book = bookOf(exposures, item?.nat ?? MOBILE_LABELS[i]);
          return (
            <div key={i} className="col-3">
              <div className="casino-box-row">
                <div className="casino-nation-name">
                  <b>{item?.nat || MOBILE_LABELS[i]}</b>
                </div>
                {' '}
                <div className="casino-bl-box">
                  <div
                    className={`back casino-bl-box-item${suspCls(item)}`}
                    onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
                  >
                    <span className="casino-box-odd">{item?.b || 0}</span>
                  </div>
                  {' '}
                  <div
                    className={`lay casino-bl-box-item${suspCls(item)}`}
                    onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}
                  >
                    <span className="casino-box-odd">{item?.l || 0}</span>
                  </div>
                </div>
                {' '}
                <div className={`casino-nation-name ${bookCls(book)}`}>{fmtBook(book)}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Mobile */}
      <div className="row row5 d-none-big">
        {items.map((item, i) => {
          const book = bookOf(exposures, item?.nat ?? MOBILE_LABELS[i]);
          return (
            <div key={i} className="casino-bl-box">
              <div className="casino-bl-box-item casino-odds-name">
                <b>{MOBILE_LABELS[i]}</b>
                {' '}
                <span className={`float-right text-success ${bookCls(book)}`}>{fmtBook(book)}</span>
              </div>
              {' '}
              <div
                className={`back casino-bl-box-item${suspCls(item)}`}
                onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
              >
                <span className="casino-box-odd">{item?.b || 0}</span>
              </div>
              {' '}
              <div
                className={`lay casino-bl-box-item${suspCls(item)}`}
                onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}
              >
                <span className="casino-box-odd">{item?.l || 0}</span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
});

export default BetTableRace17;
